var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export function parseFullUserName(name) {
    var _a;
    var curName = name.split(".")[0];
    var nameInitials = (_a = name.split(".")[1]) === null || _a === void 0 ? void 0 : _a.toUpperCase();
    if (!nameInitials)
        return name;
    var splittedName = curName.split("");
    var surnameFirstLatter = splittedName[0].toUpperCase();
    var surnameRestLeters = __spreadArray([], splittedName, true);
    surnameRestLeters.splice(0, 1);
    var result = __spreadArray([surnameFirstLatter], surnameRestLeters, true).join("") + "." + nameInitials;
    return result;
}
